var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeartBuyPromptActive = function SvgIconHeartBuyPromptActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M11.8 5.214a5.674 5.674 0 0 0-8.126 0c-2.232 2.274-2.232 5.954 0 8.228l6.898 7.03a2 2 0 0 0 2.856 0l6.898-7.03c2.232-2.274 2.232-5.954 0-8.228a5.674 5.674 0 0 0-8.126 0 .28.28 0 0 1-.4 0"
  })));
};
export default SvgIconHeartBuyPromptActive;